import { useState } from "react";

const CandidateScoreTabs = ({ item, actualProfileName }) => {
  const enriched = item.enriched_score_data;
  const profile = item?.profile;
  const [activeTab, setActiveTab] = useState("Skills");

  const SkillsTab = () => (
    <>
      {enriched.Skills?.Found && enriched.Skills?.Found?.length > 0 ? (
        <div className="mb-2">
          <span>Found in both resumes:</span>
          <div className="d-flex flex-wrap gap-2 mt-2">
            {enriched.Skills?.Found?.map((skill, idx) => (
              <span key={idx} className="badge-skill-v2">
                {skill.Skill}
              </span>
            ))}
          </div>
        </div>
      ) : null}

      {enriched.Skills?.NotFound && enriched.Skills?.NotFound?.length > 0 ? (
        <div className="mt-3">
          <span>
            Not found in <strong>{`${profile?.r_name}'s`}</strong> resume:
          </span>
          <div className="d-flex flex-wrap gap-2 mt-2">
            {enriched.Skills?.NotFound?.map((skill, idx) => (
              <span key={idx} className="badge-danger">
                {skill}
              </span>
            ))}
          </div>
        </div>
      ) : null}
    </>
  );

  const CertsTab = () => (
    <>
      {enriched.Certifications?.Found &&
      enriched.Certifications?.Found?.length > 0 ? (
        <div className="mb-2">
          <span>Found in resume and job:</span>
          <div className="d-flex flex-wrap gap-2 mt-2">
            {enriched?.Certifications?.Found?.map((cert, idx) => (
              <span key={idx} className="badge-skill-v2">
                {cert?.Skill}
              </span>
            ))}
          </div>
        </div>
      ) : null}
      {enriched.Certifications?.NotFound &&
      enriched.Certifications?.NotFound?.length > 0 ? (
        <div className="mt-3">
          <span>Not found in resume:</span>
          <div className="d-flex flex-wrap gap-2 mt-2">
            {enriched?.Certifications?.NotFound?.map((cert, idx) => (
              <span key={idx} className="badge-danger">
                {cert}
              </span>
            ))}
          </div>
        </div>
      ) : null}
      {enriched?.Certifications?.Evidence &&
      enriched.Certifications?.Evidence?.length > 0 ? (
        <div className="mt-2">
          <strong>Summary: </strong>
          {enriched?.Certifications?.Evidence?.map((summary, i) => (
            <div key={`summary-${i}`}>
              <strong>{i + 1}.</strong> {summary?.Fact}
            </div>
          ))}
        </div>
      ) : null}
    </>
  );

  const EducationTab = () => (
    <>
      {enriched?.Education ? (
        <>
          <div className="mb-2">
            <span>
              <strong>{`${profile?.r_name}'s`}</strong> education level:{" "}
            </span>
            <span className="text-success fs-6">
              {enriched?.Education?.ActualEducation}
            </span>
          </div>
          <div className="mb-2">
            <span>
              <strong>{`${actualProfileName}'s`}</strong> education level:{" "}
            </span>
            <span className="text-danger fs-6">
              {enriched?.Education?.ExpectedEducation}
            </span>
          </div>
        </>
      ) : null}
      {enriched?.Education && enriched?.Education?.Evidence?.length > 0 ? (
        <div className="mt-2">
          <strong>Summary: </strong>
          {enriched?.Education?.Evidence.map((summary, i) => (
            <div key={`summary-${i}`}>
              <strong>{i + 1}.</strong> {summary?.Fact}
            </div>
          ))}
        </div>
      ) : null}
    </>
  );

  const MgmtTab = () => (
    <>
      {enriched?.ManagementLevel ? (
        <>
          <div className="mb-2">
            <span>Actual Management Experience: </span>
            <span className="text-success fs-6">
              {enriched?.ManagementLevel?.Actual}
            </span>
          </div>
          <div className="mb-2">
            <span>Desired Management Experience: </span>
            <span className="text-danger fs-6">
              {enriched?.ManagementLevel?.Desired}
            </span>
          </div>
        </>
      ) : null}
      {enriched?.ManagementLevel &&
      enriched?.ManagementLevel?.Evidence?.length > 0 ? (
        <div className="mt-2">
          <strong>Summary: </strong>
          {enriched?.ManagementLevel?.Evidence.map((summary, i) => (
            <div key={`summary-${i}`}>
              <strong>{i + 1}.</strong> {summary?.Fact}
            </div>
          ))}
        </div>
      ) : null}
    </>
  );

  const TaxonomiesTab = () => (
    <>
      {enriched.Taxonomies?.ActualTaxonomies ? (
        <div className="mb-2">
          <strong>{`${profile?.r_name}'s`}</strong> Industries :
          <div className="d-flex flex-wrap gap-2 mt-2">
            <span>Primary: </span>
            <span>
              {enriched.Taxonomies?.ActualTaxonomies?.Primary?.Taxonomy?.Name}
            </span>
          </div>
          <div className="d-flex flex-wrap gap-2">
            <span>Secondary: </span>
            <span>
              {enriched.Taxonomies?.ActualTaxonomies?.Secondary?.Taxonomy?.Name}
            </span>
          </div>
        </div>
      ) : null}
      {enriched.Taxonomies?.DesiredTaxonomies ? (
        <div className="mb-2">
          <strong>{`${actualProfileName}'s`}</strong> Industries
          <div className="d-flex flex-wrap gap-2 mt-2">
            <span>Primary: </span>
            <span>
              {enriched.Taxonomies?.DesiredTaxonomies?.Primary?.Taxonomy?.Name}
            </span>
          </div>
          <div className="d-flex flex-wrap gap-2">
            <span>Secondary: </span>
            <span>
              {
                enriched.Taxonomies?.DesiredTaxonomies?.Secondary?.Taxonomy
                  ?.Name
              }
            </span>
          </div>
        </div>
      ) : null}
      {enriched?.Taxonomies?.Evidence &&
      enriched.Taxonomies?.Evidence?.length > 0 ? (
        <div className="mt-2">
          <strong>Summary: </strong>
          {enriched?.Taxonomies?.Evidence?.map((summary, i) => (
            <div key={`summary-${i}`}>
              <strong>{i + 1}.</strong> {summary?.Fact}
            </div>
          ))}
        </div>
      ) : null}
    </>
  );

  const LanguagesTab = () => (
    <>
      {enriched.Languages?.Found && enriched.Languages?.Found?.length > 0 ? (
        <div className="mb-2">
          <span>Current Language:</span>
          <div className="d-flex flex-wrap gap-2 mt-2">
            {enriched?.Languages?.Found?.map((item, idx) => (
              <span key={idx} className="badge-skill-v2">
                {item}
              </span>
            ))}
          </div>
        </div>
      ) : null}
      {enriched.Languages?.NotFound &&
      enriched.Languages?.NotFound?.length > 0 ? (
        <div className="mt-3">
          <span>Required Language:</span>
          <div className="d-flex flex-wrap gap-2 mt-2">
            {enriched?.Languages?.NotFound?.map((item, idx) => (
              <span key={idx} className="badge-danger">
                {item}
              </span>
            ))}
          </div>
        </div>
      ) : null}
    </>
  );

  const tabComponents = {};

  if (enriched?.Skills) {
    tabComponents.Skills = SkillsTab;
  }
  // if (enriched?.JobTitles) {
  //   tabComponents.Jobs = JobsTab;
  // }
  if (enriched?.Certifications) {
    tabComponents.Certifications = CertsTab;
  }
  if (enriched?.Education) {
    tabComponents.Education = EducationTab;
  }
  if (enriched?.ManagementLevel) {
    tabComponents["Management Experience"] = MgmtTab;
  }
  if (enriched?.Languages) {
    tabComponents.Languages = LanguagesTab;
  }
  if (enriched?.Taxonomies) {
    tabComponents["Industries"] = TaxonomiesTab;
  }

  const tabNames = Object.keys(tabComponents);
  const ActiveComponent = tabComponents[activeTab];

  return (
    <div className="p-3" style={{ backgroundColor: "rgb(240, 250, 249)" }}>
      <div className="d-flex flex-wrap gap-2 bg-white p-2 rounded">
        {tabNames.map((tab) => (
          <button
            key={tab}
            className={`btn btn-sm px-3 rounded-pill py-1 fw-medium ${
              activeTab === tab
                ? "btn-primary text-white"
                : "btn-outline-light text-dark border"
            }`}
            onClick={() => setActiveTab(tab)}
          >
            {tab}
          </button>
        ))}
      </div>

      <div className="mt-3">
        <ActiveComponent />
      </div>
    </div>
  );
};

export default CandidateScoreTabs;
